import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title (t \'Login\')}}\n\n{{#if this.model}}\n  <Page::Login::LoginSuccessful @message={{this.model}} />\n{{else}}\n  <Page::Loading />\n{{/if}}")